import React from "react";
import moment from "moment";
import { OHS_BASE_PATH } from "./ohsConstants";
import { BoxCardLink, BoxCardMeta, BoxCardTitle, ConditionBadge } from "./Ohs.styles";

/**
 * One building on the monthly checks as a clickable card (opens its check) - campus, its OHS
 * Representatives, when it was last checked, and that check's result.
 * @param {Object} props
 * @param {Object} props.building Building Checks row.
 */
function BuildingSummaryCard({ building }) {
    const hasIssues = building.last_issue_count > 0;

    return (
        <BoxCardLink to={`${OHS_BASE_PATH}/buildingChecks/check/${building.building_id}`} title="Perform Building Check">
            <span>
                <BoxCardTitle>{building.campus_name} — {building.building_name}</BoxCardTitle>
                <BoxCardMeta>
                    OHS Representatives: {building.ohs_representative_names}
                    {" · "}Last checked: {building.last_checked_at ? moment(building.last_checked_at).format("D MMM YYYY") : "never"}
                </BoxCardMeta>
            </span>
            {building.last_check_id && (
                <ConditionBadge $condition={hasIssues ? "damaged" : "ok"}>
                    {hasIssues ? `${building.last_issue_count} ${building.last_issue_count === 1 ? "issue" : "issues"} last time` : "All clear last time"}
                </ConditionBadge>
            )}
        </BoxCardLink>
    );
}

export default BuildingSummaryCard;
